var _circle, _path, _circle2, _path2, _circle3, _rect, _rect2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.926,
    height: 127,
    viewBox: "0 0 175 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 102.655,
    r: 11.5,
    fill: "#C8283B",
    stroke: "#FFFEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.149 114.046L117.813 94.1131L126.743 118.511L101.149 114.046Z",
    fill: "#C8283B",
    stroke: "#FFFEF9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 79.6545,
    r: 11.5,
    fill: "#C8283B",
    stroke: "#FFFEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.691 32.3367L164.471 29.1118L154.374 53.0503L138.691 32.3367Z",
    fill: "#C8283B",
    stroke: "#FFFEF9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 18.6545,
    r: 11.5,
    fill: "#C8283B",
    stroke: "#FFFEF9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 108.386,
    y: 51.9867,
    width: 23,
    height: 20,
    transform: "rotate(27.3747 108.386 51.9867)",
    fill: "#C8283B",
    stroke: "#FFFEF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3227,
    y: 13.9506,
    width: 23,
    height: 20,
    transform: "rotate(-35.1872 17.3227 13.9506)",
    fill: "#C8283B",
    stroke: "#FFFEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.735 82.4081L40.7784 56.5012L64.1928 67.7602L42.735 82.4081Z",
    fill: "#C8283B",
    stroke: "#FFFEF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.8ac13bf0f9a08dff39ce09a6cd25f6e0.svg";
export { ForwardRef as ReactComponent };